import {
  base_colorAction,
  base_colorActionHover,
  cta_buttonSecondaryBackground,
  cta_buttonSecondaryBackgroundHover,
  cta_buttonSecondaryBorder,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { button_hSpacing, button_vSpacing, spacing } from 'ext-ui/style/spacing'
import { button_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_medium,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
  padding: ${spacing(28)} ${spacing(4)};
`

export const illustration = css`
  width: 118px;
  height: auto;
  margin-bottom: ${spacing(5)};
`

export const heading = css`
  ${font_lg};
  font-family: ${font_family_weight_medium};
`

export const body = css`
  ${font_md};
  color: ${text_colorTextSecondary};
  margin-top: ${spacing(2)};
`

export const ctaRow = css`
  display: flex;
  gap: ${spacing(8)};
  margin-top: ${spacing(6)};
  align-items: center;
`

export const contactSupportLink = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${button_vSpacing} ${button_hSpacing};
  border-radius: ${spacing(2)};
  outline: 1px solid ${cta_buttonSecondaryBorder};
  outline-offset: -1px;
  background-color: ${cta_buttonSecondaryBackground};
  color: ${base_colorAction};
  font-family: ${font_family_weight_medium};
  ${font_md};
  line-height: 16px;
  text-decoration: none;
  cursor: pointer;
  transition:
    background-color ${button_transitionSpeed} ease-out,
    color ${button_transitionSpeed} ease-out;

  &:hover {
    background-color: ${cta_buttonSecondaryBackgroundHover};
    color: ${base_colorActionHover};
  }

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
  }
`
